import * as qpService from '@api/quotes-policies';
import { AppBarTitle } from '@components/app-bar-title';
import { DealDetail, DealStatus } from '@lib/deals';
import { IconButton } from '@material-ui/core';
import SpellcheckRoundedIcon from '@material-ui/icons/SpellcheckRounded';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { QPAddForm } from './form';
import { AddQPPayload } from '../types';
import { DateToYmdStr } from '@lib/common';


export default function AddQPPage() {
  let deal: DealDetail= {
    id: null,
    entity1: null,
    entity1_type: null,
    entity2: null,
    entity2_type: null,
    status: DealStatus.notReviewed,
    published_date: null,
    confidence: 0,
    relation: null,
    sentences: [],
  };

  // To set duplicate deal values, get deal id from queryParam
  let search = window.location.search;
  let params = new URLSearchParams(search);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const history = useHistory();

  // Form Actions
  const createDeal = useCallback(payload => {
    const infoNotification = enqueueSnackbar('Please wait Creating Quotes - Polices', {
      variant: 'info',
    });
  //  console.log(payload, 'payload');
    const requestPayload: AddQPPayload = {
      company_vtr_id: payload?.buyers?.[0]?.vtr_id?.trim() ? payload.buyers[0].vtr_id : null,
      person_vtr_id: payload?.associated_person?.[0]?.vtr_id?.trim() ? payload.associated_person[0].vtr_id : null,
      designation: payload?.associated_person?.[0]?.designation?.trim() || null,
      statement_type: payload?.statement_type,
      statement_date: DateToYmdStr(payload?.statement_date),
      source_urls: payload?.source_urls.join(',') || '',
      statement: payload?.statement,
      source: payload?.source || 'Vitrina',
    };
  //  console.log(requestPayload, 'requestPayload');
    return qpService.post(requestPayload).subscribe({
      next: () => {
        enqueueSnackbar('Quotes-Polices Created Successfully!', { variant: 'success' });
        history.push('/quotes-policies/search');
      },
      error: err =>
        enqueueSnackbar(`Error Creating Quotes/Polices (${err?.response?.data?.error})`, {
          variant: 'error',
        }),
      complete: () => closeSnackbar(infoNotification),
    });
  }, []);

    return (
      <div>
        <AppBarTitle>
          <IconButton onClick={null} color="inherit" edge="start">
            <SpellcheckRoundedIcon />
          </IconButton>
          New Quotes and Policies 
        </AppBarTitle>
        <QPAddForm deal={deal} onSubmit={createDeal} createDeal />
      </div>
    );
}
